import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'SolutionsSection' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 64,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 40
        }
    },
    cards: {
        gap: 20,
        display: 'grid',
        gridTemplateRows: 'auto',
        gridTemplateColumns: '1fr 1fr 1fr',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gridTemplateColumns: '1fr'
        }
    },
    _spanned: {
        gridRow: 'span 2'
    },
    whiteLabelIcon: {
        width: '100%',
        height: '100%'
    }
}));
